import { Helmet } from 'react-helmet'

// interface IMetaItem {
//     property: string
//     content: string
// }

interface IProps {
    isDefault: boolean
    title?: string
    description?: string
    image?: string
    // meta: Array<IMetaItem>
}

export const SEO = ({ isDefault, title, description, image }: IProps) => {
    return (
        <Helmet>
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site:id" content="@hisayasahi" />
            <meta name="twitter:creator" content="陽射矢夜叉非" />
            <meta name="twitter:title" content="Ran Van de Wereld" />
            <meta name="twitter:description"
                  content={isDefault ?
                      'WEB漫画Circle Lan連載中。陽射矢　夜叉非(ヒサヤヤサヒ)のヒユキ、ヤジにより運営。Ran Van de Wereld.'
                      : title
                  }
            />
            <meta name="twitter:image"
                  content={isDefault ?
                      "https://firebasestorage.googleapis.com/v0/b/ranvandewereld.appspot.com/o/kyoushitsu1.jpg?alt=media&token=0f716f73-52aa-403f-bc03-ef887f4a895d"
                      : image
                  }
            />

                {/*// OpenGraph tags*/}
                {/*// <meta property="og:url" content={url} />*/}
                {/*// {isBlogPost ? <meta property="og:type" content="article" /> : null}*/}
                {/*// <meta property="og:title" content={title} />*/}
                {/*// <meta property="og:description" content={description} />*/}
                {/*// <meta property="og:image" content={image} />*/}
                {/*// <meta property="fb:app_id" content={seo.social.fbAppID} />*/}

        </Helmet>
    )
}
